import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.ZONE_SHOW_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.ZONE_SHOW_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const zoneShow = (id) => {
  return async (dispatch) => {
    dispatch({ type: CONST.ZONE_SHOW_REQUEST });

    axios.get(`/zones/${id}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
